module.exports = __webpack_public_path__ + "static/media/referral-rightbg1.68a68baf.png";